interface FeatureItem {
  title: string;
  description: string;
  bullets: string[];
}

export const featurePillars: FeatureItem[] = [
  {
    title: 'Photo & Upload Management',
    description: 'Bulk intake designed for field teams with mobile capture and automated prep.',
    bullets: [
      'Upload 20–200 photos in a single drag & drop batch',
      'Mobile hand-off via QR code for on-site captures',
      'Auto compression + property-level organisation'
    ]
  },
  {
    title: 'AI Vision & Image Analysis',
    description: 'Computer vision surfaces issues, room context, and photo quality in seconds.',
    bullets: [
      'Auto room classification (Kitchen, Bathroom, etc.)',
      'Issue detection for marks, cracks, mould, and damage',
      'AI blur/darkness alerts before reports are compiled'
    ]
  },
  {
    title: 'AI Report Writing',
    description: 'LLM-powered copy drafts inspection-ready narratives you can refine on the fly.',
    bullets: [
      'Per-photo and per-room summaries with suggested actions',
      'Comment refinement tools (rewrite, shorten, formalise)',
      'Full inspection overview with intro + conclusion blocks'
    ]
  },
  {
    title: 'Report Builder & Collaboration',
    description: 'Drag-and-drop editor tailored to property management workflows.',
    bullets: [
      'Reorder rooms, merge photos, and append custom sections',
      'Shared editing for agents with role-based permissions',
      'Activity log tracks every change and export'
    ]
  },
  {
    title: 'Exports & Distribution',
    description: 'Ready-to-share outputs branded for your agency.',
    bullets: [
      'Branded PDF layouts (grid, full bleed, checklist)',
      'Signature blocks and watermark removal on paid plans',
      'Share links with access controls and view analytics'
    ]
  },
  {
    title: 'Operations & Billing',
    description: 'Stripe-powered subscriptions with usage metering and free trial limits.',
    bullets: [
      'Starter trial with one full inspection export',
      'Usage metering for report counts and PDF exports',
      'Self-service upgrades, invoicing, tax compliant'
    ]
  }
];

export const workflowHighlights = [
  'Capture: bulk upload, QR capture, automatic tagging',
  'Assess: AI issue detection, quality checks, condition scoring',
  'Compose: per-room narratives, collaborative editing, to-do actions',
  'Deliver: branded PDFs, share links, export analytics',
  'Improve: dashboard KPIs, saved views, audit-ready histories'
];

export const pricingPlans = [
  {
    name: 'Free Trial',
    headline: 'Perfect for trying InspectAI in a single property.',
    price: 'Free trial',
    description: 'One full inspection export, all AI tools included.',
    perks: ['1 inspection included', 'AI summaries with watermark', 'Standard PDF exports'],
    cta: 'Start for free'
  },
  {
    name: 'Pro',
    headline: 'Scale inspections across your property portfolio.',
    price: '$25 / month',
    description: 'Unlock full InspectAI automation for fast-moving teams.',
    perks: ['20 inspections per month', 'Branded PDF exports', 'Priority support & AI suggestions'],
    cta: 'Upgrade to Pro'
  },
  {
    name: 'Enterprise',
    headline: 'Custom workflows for large agencies and franchises.',
    price: 'Talk to us',
    description: 'Tailored onboarding, SSO, and advanced integrations.',
    perks: ['Unlimited reports', 'Dedicated success manager', 'PropertyMe, Console Cloud, API access', 'Custom data residency'],
    cta: 'Book a demo'
  }
];

export const securityHighlights = [
  {
    title: 'Security posture',
    items: [
      'Encrypted storage for images and reports',
      'Automatic session timeouts to prevent unauthorized access',
      'Regional data residency (AU) with GDPR/CCPA readiness'
    ]
  },
  {
    title: 'Compliance & privacy',
    items: [
      'Consent-driven sharing with audit logs',
      'Role-based access with principle of least privilege',
      'Configurable retention and data deletion policies'
    ]
  },
  {
    title: 'Observability',
    items: [
      'Real-time monitoring of error rates and upload health',
      'Structured activity log for inspectors and stakeholders',
      'Webhook-ready events for downstream automation'
    ]
  }
];
